<div class="flex gap-0">
    <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">Complaints
    </p>
</div>

<div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
    <div class="flex flex-row justify-between items-center">
        <div class="flex flex-row gap-6">
            <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 dark:bg-[#292929] cursor-pointer"
                [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectRecevied}" (click)="selectRecevied()">
                <i *ngIf="isSelectRecevied" class="fa-solid fa-check"></i>
                <p class="dark:text-white">Received</p>
            </div>

            <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 dark:bg-[#292929] cursor-pointer"
                [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectSent}" (click)="selectSent()">
                <i *ngIf="isSelectSent" class="fa-solid fa-check"></i>
                <p class="dark:text-white">Sent</p>
            </div>
        </div>

        <button class="bg-[#415CFF] text-white font-semibold px-4 py-2 rounded-lg shadow-lg"
            (click)="openAddComplaint()">Add
            Complaint</button>

    </div>

    <hr class="my-8 border-[1px] border-[#7F7F7F] dark:border-[#292929]" />

    <app-recevied-complaints *ngIf="isSelectRecevied" />

    <app-sended-complaint *ngIf="isSelectSent" />
</div>

<div *ngIf="isAddComplaintOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ">
    <div class="bg-white  shadow-lg rounded-lg p-6 w-1/2 dark:bg-[#363636]">
        <!-- <div class="flex justify-end items-center mb-4">
            <button class="text-red-500 font-bold text-xl" (click)="closeAddComplaint()">&times;</button>
        </div> -->
        <div>
            <h2 class="text-lg font-semibold text-center mb-2 dark:text-white">Tell us the problem</h2>
            <p class="text-base text-gray-500 text-center mb-4 dark:text-textDark">
                We will respond to you within 2 days <br />
                of receiving your message.
            </p>

            <!-- Dropdown -->
            <label for="category" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Select Complain Category
            </label>
            <!-- <select id="category" [(ngModel)]="category"
                class="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent mb-4 dark:text-textDark dark:bg-[#1D1D1F]">
                <option value="">Select Category</option>
                <option *ngFor="let item of categoryArr" [value]="item.id">{{item.categoryEnglish}}</option>

            </select> -->

            <app-searchable-dropdown [items]="categoryDropdownItems" placeholder="Select Category"
                searchPlaceholder="Search categories..." [(ngModel)]="category"
                (selectionChange)="onCategorySelectionChange($event)" [clearable]="true" [showSelected]="true"
                [disabled]="false" class="block w-full mb-4"></app-searchable-dropdown>

            <!-- Textarea -->
            <textarea rows="4" [(ngModel)]="complaint" placeholder="Kindly submit your complaint here"
                (input)="capitalizeFirstLetter($event)"
                class="block w-full px-3 py-2 border dark:bg-[#1D1D1F] border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent resize-none mb-4 dark:text-textDark "></textarea>

            <!-- Buttons -->
            <div class="flex justify-center space-x-4">
                <button (click)="closeAddComplaint()"
                    class="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-2 focus:ring-gray-200 dark:bg-[#292929] dark:text-white dark:hover:bg-gray-100 dark:hover:text-black">
                    Cancel
                </button>
                <button (click)="onSubmit()"
                    class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-300">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>